
import { GoogleGenAI, Type } from "@google/genai";

const getAI = () => new GoogleGenAI({ apiKey: process.env.API_KEY || '' });

export const professionalizeDescription = async (text: string): Promise<string> => {
  if (!text || text.trim().length < 5) return text;
  
  try {
    const ai = getAI();
    const response = await ai.models.generateContent({
      model: 'gemini-3-flash-preview',
      contents: `Du är en professionell säljare på företaget Frostpil. Förbättra följande produktbeskrivning så att den låter mer professionell och förtroendeingivande på svenska. Håll det koncist. Text: "${text}"`,
    });
    
    return response.text || text;
  } catch (error) {
    console.error("Gemini Error:", error);
    return text;
  }
};

export const generateProfessionalIntro = async (clientName: string, items: string[]): Promise<string> => {
  try {
    const ai = getAI();
    const response = await ai.models.generateContent({
      model: 'gemini-3-flash-preview',
      contents: `Skriv en kort, professionell inledning till en affärsoffert från företaget Frostpil till kunden ${clientName}. Vi erbjuder: ${items.join(', ')}. Skriv på svenska.`,
    });
    
    return response.text || "";
  } catch (error) {
    console.error("Gemini Error:", error);
    return `Här följer vår offert för de tjänster vi diskuterat.`;
  }
};
